export function extractApiError(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const msg = (err as { response?: { data?: { message?: string } } }).response
      ?.data?.message
    if (msg) return msg
  }
  if (err instanceof Error) return err.message
  return fallback
}
